import { MULTIFAMILY_RENTAL_TYPES } from './_enums';
import { isMultifamilyOrEquivalent } from '@/helpers/sector';

import { formatDate, DATE_FORMATS } from '@/helpers/date';

const getRentalTypes = (sectorType) => {
  if (isMultifamilyOrEquivalent(sectorType)) {
    return MULTIFAMILY_RENTAL_TYPES;
  }

  return [];
};

const getRecordName = (record) => {
  return `${record.record_scope}${record.buyout_date ? ` / ${formatDate(record.buyout_date, DATE_FORMATS.SHORT)}` : ''}${record.record_version ? ` / ${record.record_version}` : ''}`;
};

export { getRentalTypes, getRecordName };
